import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function situationsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return Map({
        data: null,
        loading: true,
        error: null,
      });
    case actionTypes.REQUEST_SUCCESS:
      return Map({
        data: action.payload,
        loading: false,
        error: null,
      });
    case actionTypes.REQUEST_FAILURE:
      return Map({
        data: null,
        loading: false,
        error: action.payload,
      });
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
}
